import sumDollarAmounts from '../../../helpers/sumDollarAmounts';

function getColIndexByName(colName, cols) {
  return cols.findIndex((col) => col.title === colName);
}

function sumColumnValues(tableRef, colIndex) {
  if (!tableRef.current) {
    return null;
  }

  const rows = Array.from(tableRef.current?.rows);
  const cellsToSum = [];

  rows
    .slice(1)
    .filter((row) => row.dataset.coltype !== 'total')
    .forEach((row) => {
      const cell = row.cells[colIndex];

      // Remove $ and commas from the value, preserving any minus sign
      const rawValue = cell?.textContent || '0';
      const sanitizedValue = rawValue.replace(/[$,]/g, '');
      const parsedValue = parseFloat(sanitizedValue) || 0;

      cellsToSum.push({
        value: parsedValue,
      });
    });

  return { value: sumDollarAmounts(cellsToSum, 'value') };
}

export function createTotalRow({ cols, colsWithTotals, tableRef }) {
  if (!colsWithTotals?.length) {
    return null;
  }

  const row = [];

  colsWithTotals.forEach((col) => {
    const colIndex = getColIndexByName(col, cols);
    const sum = sumColumnValues(tableRef, colIndex);

    row.push({ value: sum?.value, title: col });
  });

  return row;
}
